import { UsageExplorerManagerRowDto } from "../../types/analytics/AnalyticsPageDataDto";

export const maxManagerDistributionPoints = 150;

export function getManagerDistributionData(
  rows: UsageExplorerManagerRowDto[],
  limit = maxManagerDistributionPoints,
) {
  const eligibleRows = rows.filter(
    (row) => row.completionPercent !== null && row.teamSize > 0,
  );

  return {
    rows: eligibleRows.slice(0, limit),
    totalCount: eligibleRows.length,
  };
}
